// extracted by mini-css-extract-plugin
export var secondaryBlock = "secondary-blocks-module--secondaryBlock--93917";
export var secondaryBlocks = "secondary-blocks-module--secondaryBlocks--5c763";
export var secondaryBlocksWrapper = "secondary-blocks-module--secondaryBlocksWrapper--4f37e";